import { URLParserBase } from '@mdd/api';

export const environment = {
    production: false,
    postHogEnabled: false,
    posthogApiKey: '',
    barchartApiKey: '',
    googleApiKey: '',
    apiBase: <URLParserBase>{
        protocol: 'https',
        host: 'test.mydairydashboard.com',
        href: 'https://test.mydairydashboard.com'
    }
};
